import { render, staticRenderFns } from "./ConfigSendMode.vue?vue&type=template&id=e8cb485c"
import script from "./ConfigSendMode.vue?vue&type=script&lang=js"
export * from "./ConfigSendMode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports